import React from "react";
import { HomeworkListItem } from "API";
import HomeworkLine from "../homeworkLine";
import style from "./homeworkList.module.scss";
import { Empty } from "antd";
import { IHandleHomework } from "pages/HomeworkList";

interface HomeworkListProps {
    list: HomeworkListItem[];
    status: string;
    btnText: string;
    handleHomework: IHandleHomework;
}

const HomeworkList = ({
    list,
    status,
    btnText,
    handleHomework
}: HomeworkListProps) => {
    return (
        <div>
            {list.map(course => (
                <div
                    key={`${course.courseNo}${course.weekTime}${course.week}${course.section}`}
                    className={style.homeworkLine}>
                    <HomeworkLine
                        btnText={btnText}
                        status={status}
                        courseInfo={course}
                        handleHomework={handleHomework}
                    />
                </div>
            ))}
            {list.length === 0 && (
                <Empty className={style.empty} description="暂无数据" />
            )}
        </div>
    );
};

export default HomeworkList;
